import DevTools from './DevTools';

export default DevTools;
